import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { Reveal, Ornament, PETROL } from "@/components/home/homeUi";

const EMAIL = "enikoszasztoth@gmail.com";
const PHONE_DISPLAY = "+36 20 266 7599";
const PHONE_LINK = "+36202667599";

export function HomeUnity() {
  return (
    <section
      id="egysegben-az-ero"
      data-testid="home-unity"
      className="relative overflow-hidden px-6 md:px-10 py-12 md:py-16 bg-tinted border-t border-hairline"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[700px] rounded-full"
        style={{ background: "radial-gradient(closest-side, rgba(214,186,128,0.22), rgba(242,239,234,0) 70%)" }}
      />
      <div className="relative max-w-5xl mx-auto text-center">
        <Reveal>
          <Ornament className="mb-5" />
          <h2
            data-testid="home-unity-title"
            className="font-serif-display text-[30px] sm:text-[36px] md:text-[44px] leading-[1.18] text-graphite"
          >
            Egységben az <span className="text-gold">ERŐ</span>.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-7 md:mt-9 reading-prose font-body font-light text-graphite text-[16px] md:text-[17px] leading-[1.9]">
          <p data-testid="home-unity-body">
            Egy új kapcsolódási kultúra nem valahol tőlünk távol kezdődik. Hanem bennünk. A döntéseinkben. A hétköznapi helyzeteinkben. Abban, ahogyan önmagunkhoz és egymáshoz kapcsolódunk. Mert amikor egy ember új alapokra helyezi a saját működését, azzal lehetőséget teremt arra is, hogy a körülötte lévő kapcsolódások új minőségben épüljenek tovább.
          </p>
        </Reveal>
        <Reveal delay={0.25}>
          <p
            data-testid="home-unity-message"
            className="mt-9 md:mt-10 font-serif-display italic text-gold text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45]"
          >
            Az egység belül kezdődik, majd kapcsolódásról kapcsolódásra épül tovább.
          </p>
          <div className="mt-10 flex items-center justify-center gap-5">
            <span className="h-px w-14" style={{ background: PETROL, opacity: 0.4 }} aria-hidden="true" />
            <p data-testid="home-unity-signature" className="font-serif-display italic text-graphite text-[20px] md:text-[22px]">
              Szász-Tóth Enikő
            </p>
            <span className="h-px w-14" style={{ background: PETROL, opacity: 0.4 }} aria-hidden="true" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function HomeContact() {
  return (
    <section
      id="kapcsolat"
      data-testid="home-contact"
      className="px-6 md:px-10 py-10 md:py-12 border-t border-hairline"
    >
      <Reveal className="max-w-2xl mx-auto text-center">
        <Link
          to="/kapcsolat"
          data-testid="home-contact-cta"
          className="cta-graphite inline-flex items-center justify-center gap-3 px-10 py-4 text-[12px] md:text-[12.5px] uppercase font-body font-medium tracking-[0.24em]"
        >
          Kapcsolódjunk!
          <span aria-hidden="true">→</span>
        </Link>
        <div className="mt-7 md:mt-9 flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-10">
          <a
            href={`mailto:${EMAIL}`}
            data-testid="home-contact-email"
            className="inline-flex items-center gap-3 font-body text-[15px] md:text-[16px] text-graphite hover:text-gold transition-colors duration-300 break-all"
          >
            <Mail size={17} strokeWidth={1.3} className="text-gold shrink-0" aria-hidden="true" />
            {EMAIL}
          </a>
          <span className="hidden sm:block h-5 w-px" style={{ background: PETROL, opacity: 0.3 }} aria-hidden="true" />
          <a
            href={`tel:${PHONE_LINK}`}
            data-testid="home-contact-phone"
            className="inline-flex items-center gap-3 font-body text-[15px] md:text-[16px] text-graphite hover:text-gold transition-colors duration-300"
          >
            <Phone size={17} strokeWidth={1.3} className="text-gold shrink-0" aria-hidden="true" />
            {PHONE_DISPLAY}
          </a>
        </div>
      </Reveal>
    </section>
  );
}
